import type { ComponentProps } from 'react';
import { FieldInfo, useFieldContext } from './shared';
import { MultiCombobox } from '../../custom/multi-combobox';

export default function MultiComboboxTextField(
	props: ComponentProps<'select'> & {
		label: string;
		search: string;
		empty: string;
		options: { value: string; label: string }[];
		creatable?: boolean;
	},
) {
	const field = useFieldContext<string[]>();

	return (
		<div className={props.className}>
			<div className="text-muted-foreground relative">
				<MultiCombobox
					placeholder={props.label}
					commandEmpty={props.empty}
					searchPlaceholder={props.search}
					creatable={props.creatable}
					options={props.options}
					value={field.state.value}
					onChange={field.handleChange}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
